import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from './store';
import Login from './pages/Login';
import DriversPage from './pages/DriversPage';
import DriverDetailPage from './pages/DriverDetailPage';
import Settings from './pages/Settings';
import MainTabs from './components/MainTabs';
import AdminPage from './pages/AdminPage';
import PWAUpdateNotifier from './components/PWAUpdateNotifier';
import TestFirebaseData from './pages/TestFirebaseData';
import TestAddPhone from './pages/TestAddPhone';
import TestGroupData from './pages/TestGroupData';
import TestPhoneToGroup from './pages/TestPhoneToGroup';

const App: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  return (
    <>
      <PWAUpdateNotifier />
      <MainTabs />
      <Routes>
        <Route 
          path="/login" 
          element={user ? <Navigate to="/drivers" replace /> : <Login />} 
        />
        <Route 
          path="/drivers" 
          element={user ? <DriversPage /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/drivers/:id" 
          element={user ? <DriverDetailPage /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/settings" 
          element={user ? <Settings /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/admin" 
          element={user ? <AdminPage /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/test-firebase" 
          element={user ? <TestFirebaseData /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/test-add-phone" 
          element={user ? <TestAddPhone /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/test-group-data" 
          element={user ? <TestGroupData /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/test-phone-to-group" 
          element={user ? <TestPhoneToGroup /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/" 
          element={<Navigate to={user ? "/drivers" : "/login"} replace />} 
        />
        <Route 
          path="*" 
          element={<Navigate to={user ? "/drivers" : "/login"} replace />} 
        />
      </Routes>
    </>
  );
};

export default App; 